import React from "react";
import { Row, Col, Button, Table, Badge } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { bulkReset } from "../../../../store/bulk-schedule/actions";

const selectErrors = createSelector(
  (state) => state.BulkSchedule,
  (bs) => bs.validationErrors
);

const StepErrors = () => {
  const dispatch = useDispatch();
  const errors = useSelector(selectErrors);

  return (
    <div>
      <div className="d-flex align-items-center gap-2 mb-3">
        <i className="mdi mdi-alert-circle text-danger" style={{ fontSize: 24 }} />
        <h5 className="mb-0">Errores de validación</h5>
      </div>

      <p className="text-muted mb-3">
        Se encontraron <strong>{errors.length}</strong> error(es) en el archivo. Corrígelos y vuelve a cargar.
      </p>

      <div style={{ maxHeight: 360, overflowY: "auto" }}>
        <Table bordered size="sm" responsive>
          <thead className="table-light">
            <tr>
              <th style={{ width: 80 }}>Fila</th>
              <th style={{ width: 120 }}>Columna</th>
              <th>Descripción del error</th>
            </tr>
          </thead>
          <tbody>
            {errors.length === 0 ? (
              <tr><td colSpan={3} className="text-center text-muted">Sin errores registrados</td></tr>
            ) : (
              errors.map((err, idx) => (
                <tr key={idx}>
                  <td><Badge color="danger">{err.row ?? err.fila ?? "—"}</Badge></td>
                  <td className="text-muted">{err.column ?? err.columna ?? "—"}</td>
                  <td>{err.message ?? err.mensaje ?? err.error ?? JSON.stringify(err)}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      <Row className="mt-4">
        <Col className="text-end">
          <Button color="primary" onClick={() => dispatch(bulkReset())}>
            <i className="mdi mdi-upload me-1" />
            Corregir y volver a cargar
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default StepErrors;
